import { SelectAgriFieldAndPlanting, Planting, AgriField, SelectedPlantingAgriField } from '@/types/Component';
import moment from 'moment';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Modal from "@/assets/common/Modal/Modal.vue";
import { toCamel } from 'snake-camel';

type PreSelectItem = {
    agriFieldId: string,
    plantingId: string,
}

type PreSelectItems = {
    id: string,
    name: string,
    planting: {
        fields: Array<{
            id: string,
            name: string,
            plantedArea: number
        }>
    }
}

type SelectedPlanting = {
    id: string,
    name: string,
    fields: Array<{
        id: string,
        name: string,
        plantedArea: number
    }>
};

type PlantingData = {
    id: string;
    name: string;
};

type AgriFieldData = {
    id: string;
    name: string;
    plantedArea: number;
};

@Component({
    components: { Modal }
})
export default class SelectPlantingAndAgrifieldSplitShippping extends Vue {
    @Prop()
    private value?: boolean;

    @Emit('input')
    input(value: boolean): void {
        value
    }

    @Prop()
    private preSelectItem?: PreSelectItem;

    @Prop()
    private preSelectItems?: PreSelectItems[];

    @Prop()
    private selectedPlantingId?: string;

    @Prop()
    private selectedCropId?: string;

    @Prop()
    private plantingFieldIds?: any;

    @Prop()
    private workDate?: Date;

    @Prop()
    private showSelectFrom?: boolean;

    private selectedPlantings: SelectedPlanting[] = [];
    private selectedPlantingAgriField: SelectedPlantingAgriField[] = []
    private selectedPlantingArr: PlantingData[] = [];
    private selectedFieldsArr: AgriFieldData[] = [];

    @Emit('selectedItem')
    selectedItem(): SelectedPlantingAgriField[] {
        this.input(false);
        return this.selectedPlantings.map(item => ({
            planting: {
                id: item.id,
                name: item.name,
                fields: item.fields || []
            }
        }));
    }

    private outOfTerm = false;
    private searchWord = '';

    private plantings: Array<Planting> = []
    private filteredPlantings: Array<Planting> = []
    private displayPlantings: Array<Planting> = []

    private fromPlantingList: Partial<Record<string, Array<Planting>>> = {}
    private selectedCrop = '';
    private selectedPlanting = { id: '', name: '' };
    private selectedField = { id: '', name: '', plantedArea: 0 };
    private preSelectedPlanting = { id: '', name: '' }
    private preSelectedPlantings: SelectedPlanting[] = [];

    private displayAgriFields: Array<AgriField> = []

    private sortByPlantingFlag = 1
    private sortByTermFlag = 1
    private sortByAgriFieldFlag = 1
    preSelectItemFlag = false


    @Watch('value')
    async whenOpen(): Promise<void> {
        if (this.value) {
            const res = toCamel(await this.$apiClient.doRequest('get', `/plantings/${this.selectedCropId}/${this.selectedPlantingId}`)) as { plantings: Planting[] };
            this.plantings = res.plantings;
    
            const filterByPlanting = res.plantings.filter((p: Planting) => {
                return p.agriFields.length !== 0 && this.isWithinTheTerm(p.workStartDate, p.workEndDate);
            }).map((p: Planting) => {
                const agriField = p.agriFields.filter(af => {
                    return this.isWithinTheTerm(af.displayStart, af.displayEnd);
                });
                return { ...p, agriFields: agriField };
            });
    
            this.filteredPlantings = filterByPlanting;
            this.selectedCrop = 'すべて';
    
            if (this.preSelectItems && this.preSelectItems.length > 0) {
                const preSelectedPlantingsSet = new Set(
                    this.preSelectItems.map(item => {
                        const plantingId = item.id;
                        const fieldIds = item?.planting?.fields?.map(f => f.id) || [];
                        return { plantingId, fieldIds };
                    })
                );
    
                this.selectedPlantings = [];  
    
                this.preSelectItems.forEach(item => {
                    const { id, name } = item || {};
                    const { fields = [] } = item.planting || {};
                    const outOfTermOrIsHidden = !Array.isArray(this.filteredPlantings) ||
                        !this.filteredPlantings.some(p => p.id === id && fields.some(f => p.agriFields.some(af => f.id === af.id)));
    
                    const planting = outOfTermOrIsHidden
                        ? this.plantings.find(p => p.id === id)
                        : this.filteredPlantings.find(p => p.id === id);
    
                    const agriFields = planting?.agriFields?.filter(af => fields.some(f => f.id === af.id));
    
                    if (planting && agriFields && agriFields.length > 0) {
                        agriFields.forEach(agriField => {
                            const existingPlanting = this.selectedPlantings.find(sp => sp.id === planting.id);
    
                            if (existingPlanting) {
                                const fieldExists = existingPlanting.fields.some(f => f.id === agriField.id);
                                if (!fieldExists) {
                                    existingPlanting.fields.push({
                                        id: agriField.id,
                                        name: agriField.name,
                                        plantedArea: agriField.plantedArea
                                    });
                                }
                            } else {
                                this.selectedPlantings.push({
                                    id: planting.id,
                                    name: planting.name,
                                    fields: [{ id: agriField.id, name: agriField.name, plantedArea: agriField.plantedArea }]
                                });
                            }
                        });
                        this.selectedPlanting = { id: planting.id, name: planting.name };
                    }
                });
    
                this.preSelectItemFlag = true;
                this.filteringPlanting();
                this.selectedPlantings = this.selectedPlantings.filter(sp => {
                    const preSelected = Array.from(preSelectedPlantingsSet).find(ps => ps.plantingId === sp.id);
                    if (preSelected) {
                        sp.fields = sp.fields.filter(f => preSelected.fieldIds.includes(f.id));
                        return sp.fields.length > 0;
                    }
                    return false;
                });
            } else {
                this.selectedPlantings = []; 
                this.selectedPlantingAgriField =[]
                this.outOfTerm = false;
                this.filteringPlanting();
    
                if (this.filteredPlantings.length > 0) {
                    this.selectPlanting(this.displayPlantings[0]);
                } else {
                    this.selectedPlanting = { id: '', name: '' };
                }
            }
        } else {
            this.selectedPlantings = []; 
            this.resetSelectItem();
        }
    }
    
    private selectPlanting(planting: { id: string, name: string }) {
        const displayFirstPlanting = this.displayPlantings && this.displayPlantings[0]
        const selectedPlanting = planting ? { id: planting.id, name: planting.name } : displayFirstPlanting;
        this.selectedPlanting = selectedPlanting;
    
        const filteredArray = this.displayPlantings.filter(item =>
            item.agriFields && !item.agriFields.every(item1 =>
                !this.plantingFieldIds.some((pair: any) => pair.plantingId === item.id && pair.agriFieldId === item1.id)
            )
        );
        const selected = this.displayPlantings?.find(p => p.id === this.selectedPlanting.id)?.agriFields;
        const removeAgrifield = selected ? selected.filter(item =>
            !this.plantingFieldIds.some((pair: any) => pair.plantingId === this.selectedPlanting.id && pair.agriFieldId === item.id)
        ) : [];
        this.displayAgriFields = removeAgrifield.length ? removeAgrifield : [];
        
        if (planting.id) {
            const existingPlanting = this.selectedPlantings.find(p => p.id === planting.id);
            if (!existingPlanting) {
                this.selectedPlantings.push({
                    id: planting.id,
                    name: planting.name,
                    fields: []
                });
            }
        } else {
            this.selectedPlantings = [];
        }
    }
    
    private selectField(id: string, name: string, plantedArea: number) {
        this.preSelectedPlanting = this.selectedPlanting;
        this.selectedField = { id, name, plantedArea };
    }
    
    private checkedField(id: string) {
        return this.selectedField.id === id && this.preSelectedPlanting.id === this.selectedPlanting.id
            ? 'checked'
            : '';
    }
  
    private checkSelectPlantingKey(planting: { id: string, name: string }, isChecked: boolean) {
        const existingPlantingIndex = this.selectedPlantings.findIndex(p => p.id === planting.id);
        if (isChecked) {
            if (existingPlantingIndex === -1) {
                this.selectedPlantings.push({
                    id: planting.id,
                    name: planting.name,
                    fields: [] 
                });
            }
        } else {
            if (existingPlantingIndex !== -1) {
                this.selectedPlantings.splice(existingPlantingIndex, 1);
            }
        }
       if(this.selectedPlantings.length === 0){
        this.selectedPlantingAgriField = []
        }
        this.selectedPlanting = isChecked ? { id: planting.id, name: planting.name} : {id: "", name:   ""};
        this.preSelectedPlanting = this.selectedPlanting;
        this.preSelectedPlantings = this.selectedPlantings;
    }
    
    
    isFieldSelected(agriField: { id: string, name: string }): boolean {
        const planting = this.selectedPlantings.find(p => p.id === this.selectedPlanting.id);
        if (!planting) return false;
        return planting.fields.some(f => f.id === agriField.id);
    }
    
    isPlantingSelected(planting: { id: string, name: string }): boolean {
        if (this.selectedPlantings.length === 0) {
            return false;
        }
        const plantingExists = this.selectedPlantings.some(p => {
            if (p.fields.length > 0) {
                return p.id === planting.id;
            }
            return false; 
        });
    
        return plantingExists;
    }
    
    private backupSelectedField = { id: "", name: "", plantedArea: 0 };
    private filteringPlanting() {
        this.backupSelectedField = this.selectedField;
        const filteredBySelectedIds = this.plantings.filter((p: Planting) => {
            const cropMatches = this.selectedCropId ? p.crop.id === this.selectedCropId : true;
            const plantingMatches = this.selectedPlantingId ? p.id === this.selectedPlantingId : true;
            return cropMatches || plantingMatches;
        });
    
        this.outOfTerm = filteredBySelectedIds.length > 0;  
        this.displayPlantings = this.outOfTerm ? this.plantings : this.filteredPlantings;
    
        this.displayPlantings = this.displayPlantings.map(p => {
            const agriField = p.agriFields.filter(af => af.name.indexOf(this.searchWord) > -1);
            return { ...p, agriFields: agriField };
        }).filter(p => p.agriFields.length !== 0);
    
        if (this.displayPlantings.length > 0) {
            const isFieldSelected = this.displayPlantings.some(planting => {
                return planting.agriFields.some(val => val.id === this.selectedField.id);
            });
            const isPlantingSelected = this.displayPlantings.some(p=>{
                return this.selectedPlantings.some(p1 => p1.id === p.id)
            })
            if (!isFieldSelected) {
                this.selectField("", "", 0);
            }
        } else {
            this.selectField("", "", 0);
        }
    
        this.fromPlantingList = { 'すべて': this.displayPlantings, ...this.groupByCrop(this.displayPlantings) };
        if (!this.fromPlantingList[this.selectedCrop]) {
            this.selectedCrop = 'すべて';
        }
        this.selectPlanting(this.selectedPlanting);
    }

    // 選択状態と作付表示の初期化
    private resetSelectItem() {
        this.selectedCrop = 'すべて'
        this.selectedField = { id: '', name: '', plantedArea: 0 }
        this.selectedPlanting = { id: '', name: '' }
        this.preSelectedPlanting = { id: '', name: '' }
        this.outOfTerm = false
        this.displayPlantings = []
        this.displayAgriFields = []
        this.searchWord = ''
    }

    private isWithinTheTerm(start: Date | null | undefined, end: Date | null | undefined) {
        const workDate = moment(this.workDate)
        const startDate = moment(start)
        const endDate = moment(end)
        return (!startDate.isValid() || workDate.isSameOrAfter(startDate)) && (!endDate.isValid() || workDate.isSameOrBefore(endDate))
    }

    private groupByCrop(plantings: Array<Planting>) {
        return plantings.reduce((group, p) => {
            if (group[p.crop.name] === undefined) {
                group[p.crop.name] = []
            }
            group[p.crop.name]?.push(p)
            return group
        }, {} as Partial<Record<string, Array<Planting>>>)
    }

    private formatWorkDate(date: Date) {
        return moment(date).format('YYYY年M月D日')
    }

    private selectCrop(key: string) {
        this.selectedCrop = key
        this.displayAgriFields = []
        this.selectedPlanting = { id: '', name: '' }
        this.selectedField = { id: '', name: '', plantedArea: 0 }
    }

    private checkSelectAgriFieldKey(agriField: { id: string, name: string }, isChecked: boolean) {
        if (!this.selectedPlanting) {
            return;
        }
        const planting = this.selectedPlantings.find(p => p.id === this.selectedPlanting.id);
        if (planting) {
            if (isChecked) {
                const existingField = planting.fields.find(f => f.id === agriField.id);
                if (!existingField) {
                    planting.fields.push({
                        id: agriField.id,
                        name: agriField.name,
                        plantedArea: 0
                    });
                }
                this.selectedField = { id: agriField.id, name: agriField.name, plantedArea: 0 };
            } else {
                planting.fields = planting.fields.filter(f => f.id !== agriField.id);
                if (this.selectedField?.id === agriField.id) {
                    this.selectedField = { id: '', name: '', plantedArea: 0 };
                }
            }
        }
        this.selectedPlantingAgriField = this.selectedPlantings.map(planting => {
            const fields = planting.fields.map(field => ({
                id: field.id,
                name: field.name,
                plantedArea: field.plantedArea
            }));
            return {
                planting: {
                    id: planting.id,
                    name: planting.name,
                    fields: fields
                }
            };
        });
        this.selectedPlantingAgriField = this.selectedPlantingAgriField.filter(p => p.planting.fields.length > 0);
    }
    private sortPlantingsByName(plantings: Planting[] | undefined) {
        return plantings?.sort((a, b) => a.name > b.name ? this.sortByPlantingFlag : -this.sortByPlantingFlag)
    }

    private sortByPlanting() {
        this.sortPlantingsByName(this.displayPlantings)
        if (this.selectedCrop) {
            this.sortPlantingsByName(this.fromPlantingList[this.selectedCrop])
        }
        this.sortByPlantingFlag = -this.sortByPlantingFlag
    }

    private sortPlantingsByTerm(plantings: Planting[] | undefined) {
        return plantings?.sort((a, b) =>
            moment(a.workStartDate).isValid() && moment(b.workStartDate).isValid()
                ? moment(a.workStartDate).isSameOrBefore(moment(b.workStartDate))
                    ? this.sortByTermFlag
                    : -this.sortByTermFlag
                : 1
        )
    }

    private sortByTerm() {
        this.sortPlantingsByTerm(this.displayPlantings)
        if (this.selectedCrop) {
            this.sortPlantingsByTerm(this.fromPlantingList[this.selectedCrop])
        }
        this.sortByTermFlag = -this.sortByTermFlag
    }

    private sortByAgriField() {
        this.displayAgriFields.sort((a, b) => (
            a.name > b.name ? this.sortByAgriFieldFlag : -this.sortByAgriFieldFlag
        ))
        this.sortByAgriFieldFlag = -this.sortByAgriFieldFlag
    }

    private cancel() {
        this.input(false)
    }

    get isModalVisible(): boolean {
        return this.value ? this.value : false
    }

    set isModalVisible(value: boolean) {
        this.input(value)
    }
}
